'use strict';

const registry = require('../../dialog.registry')
const {Unit} = require("../../../../custom_components/js/unit/Unit");

module.exports = (app) => app.controller('warehouseInsertionDialogController', /* @ngInject */ function ($scope, dialogService, clientWarehouseService, unitService) {
    /**
     * @type {ClientWarehouseInsertDialogData}
     */
    $scope.data = undefined;

    /**
     * @type {WarehouseLevel[]}
     */
    $scope.matchingLevels = [];

    $scope.getAllEmptyLevels = getAllEmptyLevels;
    $scope.itemsStocked = itemsStocked;
    $scope.searchLevels = searchLevels;
    $scope.filterEmptyLevels = filterEmptyLevels;
    $scope.remainingQuantity = undefined;
    $scope.productNameSearchQuery = '';

    $scope.query = {
        emptyStorageFilterQuery: ''
    }

    /**
     * @type {WarehouseLevel[]}
     */
    $scope.filteredEmptyLevels = [];

    /**
     * @type {WarehouseLevel[]}
     */
    $scope.searchedLevels = [];

    /**
     * @type {Unit}
     */
    $scope.orderUnit;

    /**
     * @type {WarehouseLevel[]}
     */
    let emptyLevels = [];

    init();

    function init() {
        if (!$scope.data) {
            $scope.data = dialogService.getData(registry.CLIENT_WAREHOUSE_INSERT.id);
            $scope.remainingQuantity = $scope.data.quantity;
            unitService.getByUnece($scope.data.orderUnit).then(unit => $scope.orderUnit = unit);
        }
        getAllEmptyLevels();
        findMatchingStorages();
    }

    function searchLevels(query) {
        if (query) {
            clientWarehouseService.getStoragesBySearchQuery(query).then(levels => {
                $scope.searchedLevels = levels;
                $scope.$apply();
            })
        } else {
            findMatchingStorages();
        }
    }

    function filterEmptyLevels(query) {
        $scope.filteredSearchedLevels =
            $scope.query.emptyStorageFilterQuery ?
                emptyLevels.filter((l) => l.matches(query.toLowerCase())) :
                emptyLevels.slice()
    }

    function itemsStocked(itemsStocked) {
        $scope.remainingQuantity -= itemsStocked;
        if ($scope.remainingQuantity > 0) {
            init();
        } else {
            closeDialog();
        }
    }

    function closeDialog() {
        dialogService.closeDialog(registry.CLIENT_WAREHOUSE_INSERT.id, $scope.remainingQuantity);
    }

    function findMatchingStorages() {
        clientWarehouseService.searchBySupplierIdAndSupplierArticleNumber(
            $scope.data.supplierId,
            $scope.data.supplierArticleNumber
        ).then(
            /**
             * @param levels {WarehouseLevel[]}
             */
            async (levels) => {
                $scope.searchedLevels = levels?.length > 0 ?
                    levels :
                    await clientWarehouseService.getStoragesBySearchQuery('');

                $scope.$apply();
            });
    }

    function getAllEmptyLevels() {
        clientWarehouseService.getAllEmptyLevels().then(levels => {
            emptyLevels = levels;
            filterEmptyLevels('');
            $scope.$apply();
        })
    }

})
